/*
    Make sure omniture event gets triggered when user redirect away 
 */
define('shared/initializer/form/adapters/mixins/OmnitureTriggerable',[
    '$',
    'shared/lib/RSVP',
    'shared/page/runmode'
], function (
    $,
    RSVP,
    getRunMode
) {
    'use strict';

    function Ctor() { }

    function backgroundRedirect() {
        var me = this;

        return new RSVP.Promise(function(resolve){
            if (me.options.omnitureTriggerable.$iframe) {
                me.options.omnitureTriggerable.$iframe.remove();    
            }
            me.options.omnitureTriggerable.$iframe = $(document.createElement('iframe'));

            var $iframe = me.options.omnitureTriggerable.$iframe;

            $iframe
            .css({
                'visibility': 'hidden',
                'position': 'absolute',
                'top': '-9000px',
                'width': '20px',
                'height': '20px'
            })
            .attr('src', me.options.omnitureTriggerable.url)
            .on('load', function(){
                // make sure omniture pixel is sent
                // as there is no way to wait for it to be finished
                setTimeout(resolve, 3000);
            })
            .appendTo(document.body);
        });
    }
    
    Ctor.prototype.doAfterSubmit = function(data){
        var me = this;
        var url;

        if (
            me.options && 
            me.options.omnitureTriggerable &&
            me.options.omnitureTriggerable.enable === true
        ) {
            return RSVP.resolve()
                .then(function(){
                    url = me.options.omnitureTriggerable.url || '/etc/designs/b2c/others/form-default-thankyou';
                    return getRunMode();
                })
                .then(function(runmode){
                    if (runmode === 'author') {
                        url += '.html?wcmmode=disabled';
                    }

                    me.options.omnitureTriggerable.url = url;
                })
                .then(function(){
                    return backgroundRedirect.call(me);
                })
                .then(function(){
                    return data;
                });
        }
        else {
            return RSVP.resolve(data);
        }
    };

    return Ctor;
});
